import _ from 'underscore';
import $ from 'jquery';
import Promise from 'bluebird';
import { queryify, getParameter } from '@bingads-webui/url-util';
import { getPendingImportStatus } from '@bingads-webui-campaign/import-components';
/* eslint-disable import/extensions */

/* eslint-disable import/no-unresolved */
import odata from '@bingads-webui-component-legacy/http/channel/odata';

export function fetchInitData(values, isGoogleImport, isFacebookImport) {
  const actionName = `/campaign/Imports/${isGoogleImport ? 'GoogleImport' : 'FileImport'}`;
  const urlParameters = _.omit({
    uid: values.uid,
    cid: values.cid,
    aid: values.aid,
  }, value => !value);
  const isselenium = getParameter('isselenium');
  let token = null;

  if (isselenium) {
    const testAccount = getParameter('testAccount');
    if (isFacebookImport) {
      token = getParameter('token');
    }

    urlParameters.isselenium = isselenium;
    urlParameters.testAccount = testAccount;
  }

  const url = queryify(actionName, urlParameters);

  return new Promise((resolve) => {
    $.ajax({
      url,
      success: data => resolve(token ? _.extend(data, { token }) : data),
      type: 'GET',
    });
  }).catch(_.noop);
}

export function getPendingImportStatusPromise() {
  return getPendingImportStatus(odata);
}
